import axios from 'axios'
import { UrlBase } from './config'

const cancelToken = axios.CancelToken
let source = cancelToken.source()

const attendees = {}

attendees.createAttendee = (
  token,
  companyId,
  appId,
  { attendees, eventId, price, ticketId }) => {
  return new Promise((resolve, reject) => {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/events/' + eventId + '/attendees',
      data: { attendees, price, ticketId }
    }

    axios(request).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

attendees.getAttendeeInfo = (token, companyId, appId, eventId, attendeeId) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + `companies/${companyId}/apps/${appId}/events/${eventId}/attendees/info/${attendeeId}`
    }
    axios(options).then(response => {
      resolve(response.data)
    }).catch(error => {
      const message = error.response
      if (!message) return reject(new Error(error.message))
      else return reject(new Error(message.data.error))
    })
  })
}

attendees.getAttendees = (token, companyId, appId, pagination, search, advancedSearch) => {
  source.cancel('Operation canceled')
  source = cancelToken.source()
  return new Promise((resolve, reject) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        _id: advancedSearch._id,
        document: advancedSearch.document,
        eventId: advancedSearch.eventId,
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search: search,
        statusCode: 1
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/events/attendees',
      cancelToken: source.token
    }

    axios(request).then(response => {
      resolve(response.data)
    }).catch(error => {
      if (error.message !== 'Operation canceled') console.log(error)
    })
  })
}

attendees.sendSms = (token, companyId, appId, message, filters) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/events/sendsms',
      data: {
        eventId: filters.eventId,
        search: filters.search,
        message: message
      }
    }
    axios(options)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        const message = error.response
        if (!message) return reject(new Error(error.message))
        else return reject(new Error(message.data.error))
      })
  })
}

export default attendees
